<template>
  <div class="content">
    <div class="mt-20">
      <img src="https://djqsmiqswxrv8.cloudfront.net/joy2ever/web/home_title.png"  class='img-title'>
    </div>
    <div class="mt-20 mb-20">
      <img src="https://djqsmiqswxrv8.cloudfront.net/joy2ever/web/home_content.png"  class='img-content'>
    </div>
  </div>
</template>

<script>
  export default {

    data() {
      return {
      }
    },

    mounted() {
      
    },
    methods: {
     
    },
    computed: {
      
    },
  };
</script>

<style lang='less' scoped>
  .content{
    width: 100%;
    margin: 100px auto 0;
    padding: 3% 0 0;
  }
  .img-title {
    width: 60vw;
    margin-bottom:0.5vw
  }
  .img-content {
    width: 60vw;
    margin-bottom:0.5vw
  }
  .mt-20 {
    margin-top: 40vh;
  }
  .mb-20 {
    margin-bottom: 40vh;
  }
</style>



// WEBPACK FOOTER //
// src/components/Content.vue